import {authenticationService} from "../services";

export function processMessage(msg) {

    let data = JSON.parse(msg.data);
    switch (data.type) {
        case 'invalid-token':
            authenticationService.logout()
            break;
        default:
    }
    return data.data;
}
